// 微前端（京东）
import "./micro"

import Vue from "vue"
import "normalize.css/normalize.css" // A modern alternative to CSS resets

import ElementUI from "element-ui"
import "@/styles/theme/index.css"

import "@/styles/index.scss" // global css
import "@/styles/iconfont.css" // iconfont css

import App from "./App"
import store from "./store"
import router from "./router"
import "@/icons" // icon
import "@/permission" // permission control

import "@/components/index" // 注册自定义全局组件

import VueAwesomeSwiper from "vue-awesome-swiper"

import Viewer from "v-viewer"
// 图片预览插件
import "viewerjs/dist/viewer.css"
Vue.use(Viewer)

// 右下角通知
import Notify from "@/layout/components/SysNotify/components/footerSiderNotify/notify"
Vue.prototype.$footerNotify = Notify

// 导入导出右下角通知
import ImportExportNotify from "@/layout/components/importExportNotify/components/footerSiderNotify/notify"
Vue.prototype.$ImportExportNotify = ImportExportNotify

// 页面通知列表
import NotifyPagePlugin from "@/views/notify-page/index.js"
Vue.use(NotifyPagePlugin)

// 导入导出列表
import ImportExportPagePlugin from "@/views/import-export-page/index.js"
Vue.use(ImportExportPagePlugin)

import CUI from "c-ui"
import "/node_modules/c-ui/lib/styles/iconfont/iconfont.css"
Vue.use(CUI)
// 剪切板
import VueClipboard from "vue-clipboard2"
Vue.use(VueClipboard)

// 页面按钮权限判断
import { checkBtnAuth } from "@/utils/auth"
Vue.prototype.$checkBtnAuth = checkBtnAuth

Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|WebOS|Symbian|Windows Phone|Phone)/i)) {
  Vue.prototype.$isPhone = true
} else {
  Vue.prototype.$isPhone = false
}
const bus = new Vue()
Vue.prototype.$bus = bus

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
})
